import React from 'react';
import styled, { css } from 'styled-components';
import * as Bento from '@prezi/bento';
import { rtl } from '@prezi/common-components';
import * as Icons from '../../atoms/icons';
import { createDataLookup, EIGHT, HEADING_Z } from '../../const';
import { white } from '@prezi/common-design';
const HeaderContainer = styled.div.withConfig({
  displayName: "Header__HeaderContainer",
  componentId: "sc-1x3r87c-0"
})(["display:flex;align-items:center;position:sticky;top:0;background:", ";z-index:", ";min-height:", "px;border-bottom:", ";"], white, HEADING_Z, EIGHT * 7, p => p.removeBottomBorder ? 'none' : '1px solid rgb(236, 238, 241)');
const ArrowWrapper = styled.div.withConfig({
  displayName: "Header__ArrowWrapper",
  componentId: "sc-1x3r87c-1"
})(["display:flex;cursor:", ";margin-inline-end:", "px;"], p => p.onClick ? 'pointer' : 'default', EIGHT);
const ArrowIcon = styled(Icons.ArrowLeft).withConfig({
  displayName: "Header__ArrowIcon",
  componentId: "sc-1x3r87c-2"
})(["", ""], rtl(css(["transform:scaleX(-1);"])));
const Header = ({
  children,
  onBack,
  removeBottomBorder
}) => React.createElement(HeaderContainer, {
  removeBottomBorder: removeBottomBorder
}, React.createElement(ArrowWrapper, {
  onClick: onBack,
  "data-lookup": createDataLookup('header-back-cutton'),
  tabIndex: 0,
  onKeyPress: event => event.key === 'Enter' && (onBack === null || onBack === void 0 ? void 0 : onBack())
}, React.createElement(ArrowIcon, null)), React.createElement(Bento.Subtitle, null, children));
export default Header;